/**
 * API文档地址
 * http://yapi.kapeixi.cn/project/635/interface/api/cat_5390
 */
import { message } from 'ant-design-vue'
import {
  nav_query_post,
  nav_active_post,
  nav_col_list_post,
  nav_delete_id_get,
  nav_detail_id_get,
  nav_get_post,
  nav_list_post,
  nav_save_post
} from 'server/modules/5390' // 查询导航菜单配置（C端）

export const nav_query_post_ = async function(params) {
  const { success, data, retInfo } = await nav_query_post(params)

  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
} // 启用导航

export const nav_active_post_ = async function(params, state) {
  const { success, retInfo } = await nav_active_post(params)
  if (success) {
    message.success(retInfo)
    state.initList()
    state.cancelNav()
  } else {
    message.error(retInfo)
  }
} // collection列表

export const nav_col_list_post_ = async function(state) {
  const { pageNum, pageSize } = state.addonPagination
  let params = {
    ...state.postParams,
    ...state.formState,
    pageNum,
    pageSize
  }
  delete params.status
  const { success, data, retInfo } = await nav_col_list_post({
    ...params
  })
  if (success) {
    const { list, total, pageNum, pageSize } = data
    state.colList = list
    state.addonPagination = {
      ...state.addonPagination,
      total,
      pageNum,
      pageSize
    }
  } else {
    message.error(retInfo)
  }
} // 删除导航

export const nav_delete_id_get_ = async function(params, state) {
  const { success, retInfo } = await nav_delete_id_get(params)

  if (success) {
    message.success(retInfo)
    state.initList(state)
  } else {
    message.error(retInfo)
  }
} // 导航详情

// function reGender(menuList) {
//   // debugger
//   let menuList_ = [...menuList]
//   menuList.map(v => {
//     if (
//       !['', null, undefined].includes(v.menuUrl) &&
//       v.menuUrl.indexOf('?') > -1
//     ) {
//       console.log(' 有？号')
//       const splitArr = v.menuUrl.split('?')
//       console.log('splitArr', splitArr)
//       v.addonBefore = splitArr[0]
//       v.menuUrl = splitArr[1]
//     }

//     if (v.menuList) {
//       reGender(v.menuList)
//     }
//     return v
//   })
//   return menuList_
// }

export const nav_detail_id_get_ = async function(state) {
  const { success, data, retInfo } = await nav_detail_id_get({
    id: state.postParams.id
  })

  if (success) {
    const { menuList, navName, navType, subChannel, id, navStyle } = data
    state.menuList = menuList
    if (state.menuList.length) {
      state.checkIndex = 0
      if (state.menuList[state.checkIndex].menuList.length) {
        state.sonCheckIndex = 0
      }
    }
    state.postParams = {
      ...state.postParams,
      id,
      menuList,
      navName,
      navType,
      navStyle,
      subChannel: subChannel - 0
    }
  } else {
    message.error(retInfo)
  }
} // 查询导航

export const nav_get_post_ = async function(params, state, init) {
  const { success, data, retInfo } = await nav_get_post(params)
  state.postParams.subChannel = params.subChannel
  if (success) {
    const { list, index } = data
    let newData = list.map(v => {
      v.value = v.navName
      return v
    })
    state[
      params.subChannel === 1
        ? 'pcOptions'
        : params.subChannel === -1
        ? 'appOptions'
        : 'mOptions'
    ] = newData
    if (init) {
      if (newData[index]) {
        if (state.postParams.subChannel === -1) {
          state.appUnActiveIds = [newData[index].id]
        }
        state[
          params.subChannel === 1
            ? 'pcActiveId'
            : params.subChannel === -1
            ? 'appActiveId'
            : 'mActiveId'
        ] = newData[index].value
        state[
          params.subChannel === 1
            ? 'beforePcActiveId'
            : params.subChannel === -1
            ? 'beforeAppActiveId'
            : 'beforeMActiveId'
        ] = newData[index].id
      } else {
        if (state.postParams.subChannel === -1) {
          state.appUnActiveIds = []
        }
        state[
          params.subChannel === 1
            ? 'pcActiveId'
            : params.subChannel === -1
            ? 'appActiveId'
            : 'mActiveId'
        ] = null
        state[
          params.subChannel === 1
            ? 'beforePcActiveId'
            : params.subChannel === -1
            ? 'beforeAppActiveId'
            : 'beforeMActiveId'
        ] = null
      }
    }
  } else {
    message.error(retInfo)
  }
} // 导航列表

export const nav_list_post_ = async function(state) {
  let params = {
    ...state.postParams,
    ...state.pagination,
    ...state.searchParams
  }
  if (params.navType === -1) {
    delete params.navType
  }
  if (params.subChannel === -1) {
    delete params.subChannel
  }
  if (params.status === -1) {
    delete params.status
  }
  const { success, data, retInfo } = await nav_list_post(params)

  if (success) {
    const { list, pageNum, pageSize, total } = data
    state.dataSource = list
    state.pagination = {
      pageNum,
      pageSize,
      total
    }
  } else {
    message.error(retInfo)
  }
} // 保存导航

export const nav_save_post_ = async function(state = {}) {
  for (let i = 0; i < state.dataAll.length; i++) {
    let params = { ...state.dataAll[i], menuList: state.menuList }
    if ([null, '', undefined].includes(params.navName)) {
      message.warning('导航名称不能为空！')
      return
    }
    if (!params.id) {
      delete params.id
    }
    state.dataAll[i] = { ...params }
  }
  const { success, retInfo } = await nav_save_post(state.dataAll)

  if (success) {
    message.success(retInfo)
    state.jumpPage()
  } else {
    message.error('保存失败，则toast提示：“哎呀，系统开小差了，请稍后重试~')
  }
}
